import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { t } from 'utils/translates';

import MediumPreLoader from 'components/Common/PreLoaders/MediumPreLoader';

import {
  sendRequest,
  selectRequestState,
  selectData
} from 'mt-react-common/common/reducers/data/reducer';
import ListItemLink from 'components/Common/ListItemLink/ListItemLink';
import PopUpLink from 'components/Common/GlobalPopUps/PopUpLink';

const faqContentsPopularRN = 'faqContents.objects.faqContentsPopular';

class PopularItems extends Component {
  constructor(props) {
    super(props);
    props.sendRequest();
  }

  getIconStyle = name => {
    switch (name) {
      case 'kak_effektivno_polzovatsya_servisom':
        return 'fa fa-users fa-2x';
      default:
        return 'fa fa-info fa-2x';
    }
  };

  render() {
    if (this.props.requestState.inProgress || !this.props.selectData.header) {
      return <MediumPreLoader />;
    }
    return (
      <React.Fragment>
        <div className="row">
          {this.props.selectData.header.map(item => (
            <div
              className="col-xs-24 col-sm-8"
              key={`popularItemsHeader${item.id}`}
            >
              <div className="panel panel-info">
                <Link
                  className="panel-body text-center link-dark"
                  to={`/help/reference-information/view/${item.seoUrl}`}
                >
                  <div className="avatar avatar-icon avatar-icon-md avatar-icon-info avatar_inline-block">
                    <i className={this.getIconStyle(item.seoUrl)} />
                  </div>
                  <div className="text-caption max-w-180 center-block m-t-10">
                    {item.title}
                  </div>
                </Link>
              </div>
            </div>
          ))}
          <div className="col-xs-24 col-sm-8">
            <div className="panel panel-info">
              <PopUpLink
                className="panel-body text-center link-dark"
                hashName="feedback"
              >
                <div className="avatar avatar-icon avatar-icon-md avatar-icon-info avatar_inline-block">
                  <i className="fa fa-comments fa-2x" />
                </div>
                <div className="text-caption max-w-180 center-block m-t-10">
                  {t('Обратиться в поддержку')} help@taskpay.ru
                </div>
              </PopUpLink>
            </div>
          </div>
        </div>
        <div className="panel panel-default panel-heading_padding-large">
          <div className="panel-heading text-center">
            <h2 className="panel-title">
              <i className="fa fa-bookmark fa-lg" />{' '}
              {t('Популярные <strong>Разделы</strong>')}
            </h2>
          </div>
          <div className="panel-body">
            <div className="paper">
              <div className="paper-list">
                {this.props.selectData.items.map(item => (
                  <article key={`popularItems${item.id}`}>
                    <h3>
                      <Link
                        className="link-dark"
                        to={`/help/reference-information/view/${item.seoUrl}`}
                      >
                        {item.title}
                      </Link>
                    </h3>
                    <ol className="breadcrumb breadcrumb-small">
                      <ListItemLink to={`/help/reference-information`}>
                        {t('Справка')}{' '}
                      </ListItemLink>
                      {item.parent ? (
                        <ListItemLink
                          to={`/help/reference-information/view/${item.parent.seoUrl}`}
                        >
                          {item.parent.title}{' '}
                        </ListItemLink>
                      ) : null}
                      <ListItemLink
                        to={`/help/reference-information/view/${item.seoUrl}`}
                      >
                        {item.title}{' '}
                      </ListItemLink>
                    </ol>
                    <p>{item.shortDesc}</p>
                  </article>
                ))}
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

PopularItems.propTypes = {
  requestState: PropTypes.shape({
    inProgress: PropTypes.bool.isRequired
  }).isRequired,
  selectData: PropTypes.shape({
    header: PropTypes.arrayOf(PropTypes.shape),
    items: PropTypes.arrayOf(PropTypes.shape)
  }).isRequired,
  sendRequest: PropTypes.func.isRequired
};

// eslint-disable-next-line no-unused-vars
const mapStateToProps = state => ({
  requestState: selectRequestState(state, faqContentsPopularRN),
  selectData: selectData(state, faqContentsPopularRN)
});

const mapDispatchToProps = dispatch => ({
  sendRequest: () => dispatch(sendRequest(faqContentsPopularRN))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PopularItems);



// WEBPACK FOOTER //
// ./src/lauoyts/LayoutApp/Content/Help/ReferenceInformation/ContentMain/PopularItems/PopularItems.js